// extracted by mini-css-extract-plugin
export default {"Tooltip":"Tooltip_Tooltip__ZUFr9","hidden":"Tooltip_hidden__PgkB8"};